import { State } from '@/redux/reducers/rootReducer'
import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import messageBus, { MessageBusSendTypeEum, MessageBusListenTypeEum } from '@/utils/msgBusH5'
import Layout from '@/views/index'
import { isDuApp } from '@/utils/appUtils/getDevice'
import Head from 'next/head'
import Jockeys from '@/utils/jockey'
import { withReactTrack } from '@du/analytics-sdk'
import myEmitter from '@/utils/event'
import Error from '@/common/error'
import { createTrackConfig } from './trackConfig'
import style from './index.module.css'
import { EditorFlagEum, EditConfigType, ComponentItemType } from '@/typings/types'
import { LangEum, LocalEum, ShareChannelMap, TrackShareChannelMap } from '@/constant'
import handleGlobalConfig from '@/utils/jockey/handleGlobalConfig'
import {
  addComponentByIndexCreator,
  addCreator,
  changeEditConfigTypeCreator,
  changeGlobalConfigTypeCreator,
  changePropsCreator,
  copyComponentTypeCreator,
  deleteComponentTypeCreator,
  replaceComponentByIndexCreator,
  replaceComponentListTypeCreator,
  getInitPageAction,
  moveComponentType,
} from '@/redux/actions/editor'
import { getCouponList, saveCouponActivity, getUploadGoods } from '@/pages/apis'

interface IProps {
  [key: string]: any
}

interface IState {
  addFlag: boolean
  isDuappBrowser: boolean
}

const mapStateToProps = (state: State) => {
  const { editor } = state
  return {
    editConfig: editor.editConfig,
    type: editor.type,
    status: editor.status,
    componentList: editor.componentList,
    globalConfig: editor.globalConfig,
  }
}

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type shareStatus = '0' | '1' | '2'

@withReactTrack({ createTrackConfig })
class App extends Component<IProps & PropsFromRedux, IState> {
  constructor(props: IProps & PropsFromRedux) {
    super(props)
    this.state = {
      addFlag: false,
      isDuappBrowser: isDuApp(),
    }
  }

  componentDidMount() {
    const { hasGetDetail } = this.props

    // 分享设置 begin
    Jockeys.handleShareResult(
      ({
        shareStatus,
        shareChannel,
      }: {
        shareStatus: shareStatus
        shareChannel: ShareChannelMap
      }) => {
        myEmitter.emit('handleShareResult', { shareStatus, shareChannel })
      }
    )

    myEmitter.on('handleShareResult', this, function ({
      shareChannel,
    }: {
      shareChannel: ShareChannelMap
    }) {
      const map = new Map([
        [ShareChannelMap.wechat, TrackShareChannelMap.wechat],
        [ShareChannelMap.facebook, TrackShareChannelMap.facebook],
        [ShareChannelMap.messenger, TrackShareChannelMap.messenger],
        [ShareChannelMap.whatsapp, TrackShareChannelMap.whatsapp],
        [ShareChannelMap.instagram, TrackShareChannelMap.instagram],
        [ShareChannelMap.copyLink, TrackShareChannelMap.copyLink],
        [ShareChannelMap.twitter, TrackShareChannelMap.copyLink],
      ])
      this.$track('poizon_trade_page_share', {
        poizon_channel_id: map.get(String(shareChannel) as ShareChannelMap),
      })
    })

    setTimeout(() => {
      ;(this as any).$track('poizon_venue_activity_pageview')
    }, 2000)
    // 分享设置 end

    // 绑定 listener
    window.editorFlag = this.props.editConfig.editorFlag
    if (!hasGetDetail) {
      // SPA，需要重新发起请求
      // spa 设置 editorFlag
      try {
        const pathname = location.pathname
        const pathArr = pathname.split('/')
        window.editorFlag = pathArr[2]
        this.getActivityDetail().then((res) => {
          handleGlobalConfig(res.payload.globalConfig)
        })
      } catch {
        // noop
      }
    } else {
      // SSR
      handleGlobalConfig(this.props.globalConfig)
    }

    if (window.editorFlag === EditorFlagEum.edit) {
      this.initListener()
    }
  }

  getActivityDetail = async () => {
    try {
      const { dispatch } = this.props
      // 这个地方这个方法有问题，谁有时间建议复查下
      const pathList = (window?.location?.pathname || '').split('/').slice(2)

      if (Array.isArray(pathList) && pathList.length === 4) {
        let [editorFlag, lang, local, id] = pathList

        if (this.props.editConfig.lang) {
          lang = this.props.editConfig.lang
          local = this.props.editConfig.local
        }

        const editConfig: EditConfigType = {
          lang: lang as LangEum,
          local: local as LocalEum,
          id,
          editorFlag: editorFlag as EditorFlagEum,
        }
        const action = await getInitPageAction({ editConfig })
        dispatch(action)
        return action
      }
    } catch (error) {
      console.log('error: getActivityDetail', error.message)
    }
  }

  initListener = () => {
    const { dispatch } = this.props
    messageBus.init()
    messageBus.listen(MessageBusListenTypeEum.addComponent, (item) => {
      dispatch(addCreator(item))
    })
    messageBus.listen(MessageBusListenTypeEum.changeComponent, ({ index, props }) => {
      dispatch(changePropsCreator({ index, props }))
      this.handleLayOutInfo()
    })
    messageBus.listen(MessageBusListenTypeEum.addComponentByIndex, ({ name, props, index }) => {
      this.setState({
        addFlag: true,
      })
      dispatch(addComponentByIndexCreator({ name, props, index }))
      this.handleLayOutInfo()
    })
    messageBus.listen(MessageBusListenTypeEum.replaceComponentByIndex, ({ name, props, index }) => {
      this.setState({
        addFlag: true,
      })
      dispatch(replaceComponentByIndexCreator({ name, props, index }))
      this.handleLayOutInfo()
    })
    messageBus.listen(MessageBusListenTypeEum.copyComponent, ({ index }) => {
      dispatch(copyComponentTypeCreator({ index }))
      this.handleLayOutInfo()
    })
    messageBus.listen(MessageBusListenTypeEum.deleteComponent, ({ index }) => {
      dispatch(deleteComponentTypeCreator({ index }))
      this.handleLayOutInfo()
    })
    messageBus.listen(MessageBusListenTypeEum.changeGlobalConfig, (item) => {
      dispatch(changeGlobalConfigTypeCreator(item))
      this.handleLayOutInfo()
    })
    // 刷新数据空是因为这个变化，重点检测
    messageBus.listen(MessageBusListenTypeEum.replaceComponentList, (data) => {
      dispatch(replaceComponentListTypeCreator(data))
      this.handleLayOutInfo()
    })
    // 语言变化的时候的渲染失败了, 原因就是这里修改数据没有加上hash key变更
    messageBus.listen(MessageBusListenTypeEum.getEditConfig, (editConfig) => {
      dispatch(changeEditConfigTypeCreator(editConfig))
      this.handleLayOutInfo()
    })

    messageBus.listen(
      MessageBusListenTypeEum.moveComponent,
      ({ name, props, index, activeIndex }) => {
        dispatch({
          type: moveComponentType,
          payload: {
            name,
            props,
            index,
            activeIndex,
          },
        })
        this.handleLayOutInfo()
      }
    )
    messageBus.listen(MessageBusListenTypeEum.getCouponList, async (templateId) => {
      try {
        const res = await getCouponList(templateId)
        messageBus.send(MessageBusSendTypeEum.sendCouponList, res)
      } catch (err) {
        messageBus.send(MessageBusSendTypeEum.sendCouponList, err)
      }
    })
    messageBus.listen(MessageBusListenTypeEum.saveCouponActivity, async (data) => {
      try {
        const res = await saveCouponActivity(data)
        messageBus.send(MessageBusSendTypeEum.saveCouponActivityRes, res)
      } catch (err) {
        messageBus.send(MessageBusSendTypeEum.saveCouponActivityRes, err)
      }
    })

    // 商品一排一组件 移动端请求pc端数据 并通信回显
    messageBus.listen(MessageBusListenTypeEum.poizonARowGoodsGetList, async (fileUrl) => {
      try {
        const { local: region, lang: language } = this.props.editConfig
        const res = await getUploadGoods({ fileUrl, region, language })
        messageBus.send(MessageBusSendTypeEum.poizonARowGoodsSetList, res)
      } catch (err) {
        console.warn(err)
        messageBus.send(MessageBusSendTypeEum.poizonARowGoodsSetList, err)
      }
    })
  }

  refreshLayout = () => {
    const { componentList } = this.props
    const classList = componentList.map(({ name }, index) => {
      return `${name}___${index}`
    })
    const layoutBoxDom = document.querySelector(`.layout__box`)
    if (layoutBoxDom === null) {
      return
    }
    messageBus.send(MessageBusSendTypeEum.layOutInfo, {
      h5BodyHeight: (layoutBoxDom as HTMLElement).offsetHeight,
      list: classList.map((className) => {
        const dom = document.querySelector(`.${className}`)
        return {
          top: dom ? dom.getBoundingClientRect().top : 0,
          height: dom ? (dom as HTMLElement).offsetHeight : 0,
        }
      }),
    })
  }

  handleLayOutInfo = (time = 800, init = false) => {
    // TODO 精简
    // 添加一个‘准备完毕’事件，接收到 再发‘layOutInfo’
    setTimeout(() => {
      this.refreshLayout.call(this)
    }, time)
    if (init) {
      setInterval(() => {
        console.log('刷新layout')
        this.refreshLayout.call(this)
      }, 10000)
    }
  }

  handleChangeActive = (index: number) => {
    // 插入状态下不相应切换
    if (this.state.addFlag) {
      return
    }
    messageBus.send(MessageBusSendTypeEum.changeActiveIndex, index)
  }

  getPageTitle = (defaultTitle: string, compList: ComponentItemType[]) => {
    const pageTitleItem = compList.find((it) => it.name === 'poizon-page-title')
    if (pageTitleItem?.propsConfig?.pageTitle) {
      return pageTitleItem?.propsConfig?.pageTitle
    }
    return defaultTitle
  }

  render() {
    const { componentList, globalConfig, status, type, editConfig } = this.props
    const isReady = componentList.length && globalConfig
    if (!isReady) return <div></div>
    console.log('render', componentList)

    const { addFlag } = this.state
    if (editConfig.editorFlag === EditorFlagEum.detail && status === -1) {
      // 活动未生效
      return (
        <div className={style.errorbox}>
          <Error message="活动未生效~~~" />
        </div>
      )
    }
    if (editConfig.editorFlag === EditorFlagEum.detail && status === 2) {
      // 活动已失效
      return (
        <div className={style.errorbox}>
          <Error message="活动已失效~~~" />
        </div>
      )
    }
    return (
      <div className={`layout__box ${style.normal}`}>
        <Head>
          <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
          <title>{this.getPageTitle(globalConfig.title || 'poizon', componentList)}</title>
        </Head>
        <Layout
          globalConfig={globalConfig}
          addFlag={addFlag}
          componentList={componentList}
          handleChangeActive={this.handleChangeActive}
          isDuappBrowser={isDuApp()}
          id={this.props.editConfig.id}
          editConfig={editConfig}
          type={type}
        />
      </div>
    )
  }
}

export default connector(App)
